import React from 'react';
import { Key } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';
import { CopyButton } from './CopyButton';

export const NewKeyDialog = ({ newKey, onClose }) => (
  <Dialog open={!!newKey} onOpenChange={onClose}>
    <DialogContent className="bg-slate-50 border-slate-200 text-slate-900" data-testid="new-key-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Key className="w-5 h-5 text-indigo-700" /> Nova chave de API gerada
        </DialogTitle>
        <DialogDescription className="text-slate-500">
          Copie esta chave agora. Por segurança, não será mostrada novamente.
        </DialogDescription>
      </DialogHeader>
      <div className="flex items-center gap-2 p-3 bg-white rounded-lg">
        <code className="text-indigo-700 text-sm break-all flex-1">{newKey}</code>
        <CopyButton value={newKey} />
      </div>
      <DialogFooter>
        <Button onClick={onClose} className="bg-indigo-700 hover:bg-amber-600 text-black" data-testid="close-key-dialog-btn">
          Já copiei a chave
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
